import { SparklesIcon } from "@heroicons/react/24/solid";
import { Children } from "react";

import { Button } from "@/components/clickable";
import useActiveHeading from "./useActiveHeading";

export default function ContentsTable({ headings }) {
  const activeId = useActiveHeading(headings);

  const openChat = () => {
    const chat = document.querySelector('[aria-label="Open chat"]');
    chat.click();
  };

  return (
    <div className="sticky top-4 w-56 p-4">
      <h2 className="text-cp-grey-500 mb-6 text-sm font-semibold">
        TABLE OF CONTENTS
      </h2>
      <ul className="space-y-1">
        {Children.toArray(
          headings.map((heading) => (
            <li>
              <a
                href={`#${heading.id}`}
                className={`text-cp-grey-800 underline ${
                  activeId === heading.id ? "font-semibold text-black" : ""
                }`}
              >
                {heading.text}
              </a>
            </li>
          )),
        )}
      </ul>

      <p className="mt-6 text-xs text-gray-600">
        Want more info? Chat with an AI Forensic Accountant
      </p>
      <a href="#daystrom-chat">
        <Button
          color="white"
          onClick={openChat}
          className="mt-2 w-44 font-normal"
        >
          <SparklesIcon className="fill-cp-primary-200 mr-2 h-5 w-5" />
          Chat with Daystrom
        </Button>
      </a>
    </div>
  );
}
